import {FavoritesController} from "@share/favorites/controller/FavoritesController";
import {RealtimeRepository} from "@api/repositories/reatime-repository/RealtimeRepository";
import {parseJson} from "@common/TypesHelper";
import {Store} from "vuex";
import {Observers, RealtimeMessageModel, SignalRMethod} from "@api/repositories/reatime-repository/types";
import {Element} from "@api/models/Element";
import {Rating} from "@api/models/Rating";

//@todo make the observer common
export class AgendaUpdateObserver {
    private readonly observers: Observers;

    constructor(
        private readonly controller: FavoritesController,
        private readonly repository: RealtimeRepository,
        private readonly store: Store<any>
    ) {
        this.observers = {
            [this.channelName]: {
                [SignalRMethod.objectUpdated]: this.objectHandler.bind(this),
                [SignalRMethod.objectLikesUpdated]: this.likesHandler.bind(this),
                [SignalRMethod.objectCommentsCountUpdated]: this.commentsHandler.bind(this)
            }
        }
    }

    private get lang() {
        return this.store.state.session.language || 'en';
    }

    private get channelName(): string {
        return `objects.${this.controller.agendaService.schema}.${this.lang}`;
    }

    private parseMessage(data: any) {
        return parseJson(data) as RealtimeMessageModel
    }

    private async objectHandler(data: any): Promise<void> {
        const update = this.parseMessage(data);
        if (this.controller?.isLoaded) {
            const newAgenda = new Element(update.data, update.schemaId);
            this.controller?.updateAgenda(newAgenda);
        }
    }

    private async commentsHandler(data: any): Promise<void> {
        const update = this.parseMessage(data);
        if (update.objectId && update.comments !== undefined) {
            await this.controller.updateComments(update.objectId, update.comments);
        }
    }

    private async likesHandler(data: any): Promise<void> {
        const update = this.parseMessage(data);
        if (update.objectId && update.likes !== undefined) {
            await this.controller.updateLikes(update.objectId, update.likes);
        }
    }

    async connect() {
        try {
            await this.repository.attach(this.observers);
            return true;
        }
        catch (e) {
            this.store.dispatch('reportException', e);
        }
        return false;
    }

    async disconnect() {
        try {
            await this.repository.detach(this.observers);
        }
        catch (e) {
            this.store.dispatch('reportException', e);
        }
    }
}
